import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { getDepositRangeValue, getInhouseEligibility, getPreApprovalLoanDetails, getInhousePreApprovalLoanDetails } from "../pre-approval-financing-flow/pre-approval-loan-wrapper/actions";
import MyAccountSidebar from "./component";

const mapStateToProps = ({
    preApprovalLoan: {
        preApprovalEditMode
    },
    user: {
        userProfiles,
        isLoggedIn,
        profileName,
        secureToken,
        isFetched
    }
}) => ({
    preApprovalEditMode,
    userProfiles,
    isLoggedIn,
    profileName,
    secureToken,
    isFetched
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    getPreApprovalLoanDetailsConnect: getPreApprovalLoanDetails,
    getDepositRangeValueConnect: getDepositRangeValue,
    getInhouseEligibilityConnect: getInhouseEligibility,
    getInhousePreApprovalLoanDetailsConnect: getInhousePreApprovalLoanDetails
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(MyAccountSidebar);
